/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../../apiClient";

function AddDistrict({ onClose, onSuccess, onFailed, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [state, setState] = useState([]);
  const [editData, setEditData] = useState(editFormData);

  useEffect(() => {
    getState();
  }, []);

  const getState = async () => {
    const response = await apiClient.get("/admin/state");
    if (response.status === 200) {
      setState(response.data);
    }
  };

  const [formData, setFormData] = useState({
    state: editData.state || "",
    stateId: editData.stateId || "",
    name: editData.name || "",
    status: editData.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    // Determine whether it's a POST or PUT request
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      let payload = {
        stateId: formData.stateId,
        state: state.find((item) => item._id === formData.stateId).name || "",
        name: formData.name,
        status: formData.status,
      };
      console.log("Form data submitted:", payload, editData);
      const endpoint = isEdit ? `/admin/district/update/${editData._id}` : "/admin/district"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create

      // Make the API request
      const response = await method(endpoint, payload);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating district:", response.data.message);
          // showing failed message in snackbar
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error(isEdit ? "Error updating district:" : "Error creating district:", error);
    }
  };

  return (
    <Card id="add-coupons">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">State</InputLabel>
                <Select
                  label="state"
                  name="stateId"
                  value={formData.stateId}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                    "& .MuiSelect-icon": {
                      color: darkMode ? "#fff" : "#000",
                      display: "block",
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {state &&
                    state.length > 0 &&
                    state.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="District Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                fullWidth
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                sx={{
                  height: "40px",
                  "& .MuiSelect-icon": {
                    color: darkMode ? "#fff" : "#000",
                    display: "block",
                  },
                }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddDistrict;
